import queryString from "query-string";
/** UTILS */

// Construction route to navigate
export const buildTargetUrl = (segment, query) =>
  `/${segment}${query ? `?${query}` : ""}`;

// Parameters to be ignored in the visual comparison
const IGNORED_KEYS = ["limit", "offset"];

export const isExactMatch = (
  location,
  segment,
  query = "",
  activeMatch = []
) => {
  const currentPath = location.pathname;
  const targetPath = `/${segment}`;

  // If path does not match, check for partial match
  if (currentPath !== targetPath) {
    return activeMatch.some((match) => currentPath.includes(match));
  }

  const currentParams = queryString.parse(location.search);
  const targetParams = queryString.parse(query);

  // Delete ignored keys (pagination)
  const cleanCurrent = Object.fromEntries(
    Object.entries(currentParams).filter(([k]) => !IGNORED_KEYS.includes(k))
  );
  const cleanTarget = Object.fromEntries(
    Object.entries(targetParams).filter(([k]) => !IGNORED_KEYS.includes(k))
  );

  // Compare shallowly (including arrays)
  return (
    Object.keys(cleanCurrent).length === Object.keys(cleanTarget).length &&
    Object.entries(cleanTarget).every(([key, val]) => {
      const currentVal = cleanCurrent[key];
      if (Array.isArray(val) && Array.isArray(currentVal)) {
        return (
          val.length === currentVal.length &&
          val.every((v, i) => v === currentVal[i])
        );
      }
      return val === currentVal;
    })
  );
};

// Determines selected segment (active)
export const isChildActive = (group, location) => {
  if (!group?.children?.length) return false;
  return group.children.some((child) => {
    if (child.kind === "item") {
      return isExactMatch(
        location,
        child.segment,
        child.query,
        child.activeMatch
      );
    }
    if (child.kind === "group") {
      return isChildActive(child, location);
    }
    return false;
  });
};
